import App from './components/App'
import reducer from './reducer'

export default App;

export { reducer }



// WEBPACK FOOTER //
// ./src/App/index.js